import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import SaveIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import PropTypes from "prop-types";
import React, { Component } from "react";
// open source
import { BlockPicker } from "react-color";
// styles
import styles from "./styles";

class FormSupportItemType extends Component {
  static propTypes = {
    classes: PropTypes.object,
    supportItemTypes: PropTypes.object,
    fullScreen: PropTypes.bool,

    close: PropTypes.func,
    open: PropTypes.bool,

    supportItemType: PropTypes.object,

    createSupportItemType: PropTypes.func,
    updateSupportItemType: PropTypes.func,
    deleteSupportItemType: PropTypes.func,
    refresh: PropTypes.func,
  };

  static contextTypes = {
    NotificationCenter: PropTypes.object,
  };

  constructor(...args) {
    super(...args);
    this.state = {
      loading: false,
      name: "",
      description: "",
      color: "",
      icon: "",
      tagID: "",
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.open && !this.props.open) {
      this.init(nextProps.supportItemType);
    }
  }

  handleChange = (name) => (event) => {
    const { target } = event;
    const { value } = target;

    this.setState({
      [name]: value,
    });
  };

  init(supportItemType) {
    this.setState({
      loading: false,
      name: supportItemType ? supportItemType.name : "",
      description: supportItemType ? supportItemType.description : "",
      color: supportItemType ? supportItemType.color : "",
      icon: supportItemType ? supportItemType.icon : "",
      tagID: supportItemType ? supportItemType.tagID : "",
    });
  }

  delete() {
    const { NotificationCenter } = this.context;
    NotificationCenter.sweetAlert(
      {
        title: "Are you sure ?",
        subtitle:
          "If you delete this support Item Type, you won't be able to recover it.",
        timestamp: new Date().getTime(),
        error: true,
      },
      {
        cancel: {
          label: "Cancel",
          level: "default",
          callback: () => console.log("Callback"),
        },
        confirm: {
          label: "I am sure",
          level: "error",
          callback: this.confirmDelete.bind(this),
        },
      }
    );
  }

  async confirmDelete() {
    const {
      deleteSupportItemType,
      close,
      refresh,
      supportItemType,
    } = this.props;

    const { NotificationCenter } = this.context;
    close();
    const resp = await deleteSupportItemType(supportItemType.id);
    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: "Support Item Type has been deleted.",
        success: true,
        timestamp: new Date().getTime(),
      });
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  async save() {
    const {
      updateSupportItemType,
      createSupportItemType,
      supportItemType,
      refresh,
      close,
    } = this.props;

    const { name, description, color, icon, tagID } = this.state;

    const { NotificationCenter } = this.context;

    let resp;
    this.setState({ loading: true });
    if (supportItemType) {
      resp = await updateSupportItemType(supportItemType.id, {
        name,
        description,
        color,
        icon,
        tagID: Number(tagID),
      });
    } else {
      resp = await createSupportItemType({
        name,
        description,
        color,
        icon,
        tagID: Number(tagID),
      });
    }

    this.setState({ loading: false });

    if (resp.success) {
      NotificationCenter.sweetAlert({
        title: supportItemType
          ? "Support Item Type has been updated."
          : "Support Item Type has been created.",
        success: true,
        timestamp: new Date().getTime(),
      });

      close();
      refresh();
      setTimeout(NotificationCenter.hide, 1500);
    }
  }

  render() {
    const { classes, fullScreen, open, supportItemType, close } = this.props;

    const { name, description, color, icon, tagID, loading } = this.state;

    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        scroll="paper"
        onClose={close}
        aria-labelledby="responsive-dialog-title"
      >
        {loading ? (
          <div className={classes.progressContainer}>
            <DialogTitle id="alert-dialog-title">Loading</DialogTitle>
            <CircularProgress />
          </div>
        ) : (
          <div>
            <DialogTitle id="responsive-dialog-title">
              {supportItemType
                ? `${supportItemType.name}`
                : "Let's Create a New Support Item Type"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                {supportItemType
                  ? "To update the support Item Type, fill the form bellow :"
                  : "To create a new support Item Type, fill the form bellow :"}
              </DialogContentText>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    id="name"
                    label="Name"
                    className={classes.textField}
                    value={name}
                    onChange={this.handleChange("name")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    multiline
                    id="description"
                    label="Description"
                    className={classes.textField}
                    value={description}
                    onChange={this.handleChange("description")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <BlockPicker
                    color={color}
                    onChange={(c) => {
                      this.setState({
                        color: c.hex,
                      });
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="icon"
                    label="Icon"
                    className={classes.textField}
                    value={icon}
                    onChange={this.handleChange("icon")}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="tagID"
                    label="Tag ID"
                    className={classes.textField}
                    value={tagID}
                    onChange={this.handleChange("tagID")}
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              {supportItemType && (
                <Button
                  className={classes.delete}
                  onClick={this.delete.bind(this)}
                >
                  <DeleteIcon className={classes.leftIcon} />
                  &nbsp;Delete
                </Button>
              )}
              <Button onClick={close}>
                <CloseIcon className={classes.leftIcon} />
                &nbsp;Close
              </Button>
              <Button color="primary" autoFocus onClick={this.save.bind(this)}>
                <SaveIcon className={classes.leftIcon} />
                {supportItemType ? "Save" : "Create"}
              </Button>
            </DialogActions>
          </div>
        )}
      </Dialog>
    );
  }
}

export default withStyles(styles)(withMobileDialog()(FormSupportItemType));
